//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Annotations.js";
import "../no/Builder.js";
import "../Annotations/Annotations.FeatureControlFrameDataBuilderList.js";
import "../Annotations/Annotations.LeaderBuilder.js";
import "../Annotations/Annotations.OriginBuilder.js";
import "../Annotations/Annotations.StyleBuilder.js";
import "../Annotations/Annotations.TextWithSymbolsBuilder.js";
import "../no/ObjectList.js";
let d=[[[0,"Characteristic",1,0],[1,"FeatureControlFrameDataList",0,"Annotations.FeatureControlFrameDataBuilderList",0],[0,"FrameStyle",1,0],[1,"Leader",0,"Annotations.LeaderBuilder",0],[1,"Origin",0,"Annotations.OriginBuilder",0],[1,"Style",0,"Annotations.StyleBuilder",0],[1,"Text",0,"Annotations.TextWithSymbolsBuilder",0]],[[["numFeatureControlFrameDataElements","featureControlFrameDataBuilders"],"FeatureControlFrameData",{},0,0],[["inheritTag"],"InheritFrom",{},1,0]],[]];
SPLM.Annotations.FeatureControlFrameBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Annotations.FeatureControlFrameBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Annotations.FeatureControlFrameBuilder.FcfCharacteristic = Object.freeze({
    "Straightness" : "Straightness", "Flatness" : "Flatness", "Circularity" : "Circularity", "Cylindricity" : "Cylindricity", "ProfileOfALine" : "ProfileOfALine", "ProfileOfASurface" : "ProfileOfASurface", "Angularity" : "Angularity", "Perpendicularity" : "Perpendicularity", "Parallelism" : "Parallelism", "Position" : "Position", "Concentricity" : "Concentricity", "Symmetry" : "Symmetry", "CircularRunout" : "CircularRunout", "TotalRunout" : "TotalRunout", "AxisIntersection" : "AxisIntersection"});

SPLM.Annotations.FeatureControlFrameBuilder.FcfFrameStyle = Object.freeze({
    "SingleFrame" : "SingleFrame", "CompositeFrame" : "CompositeFrame"});

export default SPLM;